<div class="driverLevel_container">
    <div class="driverLevel_levelData" (click)="onDriverIconClicked()">
        <mat-icon *ngIf="presentRaiseLevel" class="driverLevel_actionIcon" [style.color]="'#A2A2A2'">add</mat-icon>
        <mat-icon *ngIf="showEnergyLevels && !isMemberInCareerProcess" class="driverLevel_levelIcon" [style.color]="levelColor">{{levelIcon}}</mat-icon>
        <mat-icon *ngIf="!showEnergyLevels || isMemberInCareerProcess" class="driverLevel_levelIcon">{{icon}}</mat-icon>
    </div>
        <mat-divider vertical class="driverLevel_divider" [style.height]="'20px'"></mat-divider>
    <div class="driverLever-driverData" (click)="onDriverNameClicked()">
        <span class="driverLevel_driverName">{{name}}</span>
    </div>
</div>